<template>
    <header-component></header-component>
    <router-view/>
    <img src="@/assets/images/circle-large.svg" :alt="$t('general.background-alt')" class="circle circle--large" />
    <img src="@/assets/images/circle-medium.svg" :alt="$t('general.background-alt')" :class="['circle circle--medium', {'circle--hide': hideBackgroundCircleMobile}]" />
    <img src="@/assets/images/circle-small.svg" :alt="$t('general.background-alt')" :class="['circle circle--small', {'circle--hide': hideBackgroundCircleMobile}]" />
</template>

<script>
import HeaderComponent from './components/HeaderComponent.vue';

export default {
    components: {
        HeaderComponent
    },
    provide() {
        return {
            formatValue: this.formatValue,
            formatValueWithUnit: this.formatValueWithUnit,
            formatUnit: this.formatUnit,
            calculateFullPrice: this.calculateFullPrice,
            isMobile: this.isMobile,
            scrollTrigger: this.scrollTrigger,
            addObserver: this.addObserver
        }
    },
    computed: {
        hideBackgroundCircleMobile() {
            return this.$route.meta.hideBackgroundCircleMobile;
        },
        currency() {
            return this.$store.getters['game/getBudgetCurrency'];
        },
        surfaceArea() {
            return this.$store.getters['game/getSurfaceArea'];
        },
        gardenSurfaceArea() {
            return this.$store.getters['game/getGardenSurfaceArea'];
        },
        hipRoofSurfaceArea() {
            return this.$store.getters['game/getHipRoofSurfaceArea'];
        },
        windowQuantity() {
            return this.$store.getters['game/getWindowQuantity'];
        }
    },
    methods: {
        formatValue(value) {
            return Number(value).toLocaleString('hr');
        },
        formatValueWithUnit(value, unit) {
            let formattedValue = Number(value).toLocaleString('hr');
            let formattedUnit;

            if (unit == null || unit.abbreviation == null) {
                formattedUnit = this.currency;
            } else if (unit.abbreviation == 'm2') {
                formattedUnit = `m<sup>2</sup>`;
            } else if (unit.abbreviation == 'eur-m2') {
                formattedUnit = `EUR/m<sup>2</sup>`;
            } else {
                formattedUnit = unit.abbreviation;
            }

            return `${formattedValue} ${formattedUnit}`;
        },
        formatUnit(unit) {
            let formattedUnit;

            if (unit == null || unit.abbreviation == null) {
                formattedUnit = this.currency;
            } else if (unit.abbreviation == 'm2') {
                formattedUnit = `m<sup>2</sup>`;
            } else if (unit.abbreviation == 'eur-m2') {
                formattedUnit = `EUR/m<sup>2</sup>`;
            } else {
                formattedUnit = unit.abbreviation;
            }

            return `${formattedUnit}`;
        },
        calculateFullPrice(name, price, unit, phase) {
            let fullPrice;

            if (phase.toLowerCase().includes('stolarija')) {
                fullPrice = parseInt(price) * this.windowQuantity;
            } else if (phase.toLowerCase().includes('okućnica')) {
                fullPrice = parseInt(price) * this.gardenSurfaceArea;
            } else if (name.toLowerCase().includes('kosi krov')) {
                fullPrice = parseInt(price) * this.hipRoofSurfaceArea;
            } else if (unit.abbreviation == null) {
                fullPrice = parseInt(price);
            } else {
                fullPrice = parseInt(price) * this.surfaceArea;
            }

            return fullPrice;
        },
        isMobile() {
            if (window.innerWidth <= 767) {
                return true;
            } else {
                return false;
            }
        },
        scrollTrigger(selector, options = {}) {
            let els = document.querySelectorAll(selector);
            els = Array.from(els);
            els.forEach(el => {
                this.addObserver(el, options);
            });
        },
        addObserver(el, options) {
            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                        const animation = entry.target.getAttribute('data-animation');
                        entry.target.classList.add(`animate__${animation}`);
                        observer.unobserve(entry.target);
                    }
                })
            }, options);
            observer.observe(el);
        }
    },
    mounted() {
        
    }
}
</script>
